module.exports = __webpack_public_path__ + "img/pictoEstablishementsCommon3.84999bcc.svg";